import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import catalogReducer from './slices/catalog';
import categoryReducer from './slices/category';
import subscriptionReducer from './slices/subscription';
import userRequestReducer from './slices/userRequest';
import stripeReducer from './slices/stripe';

import userReducer from './slices/user';
import productReducer from './slices/product';

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};

const rootReducer = combineReducers({
  catalog: catalogReducer,
  category: categoryReducer,
  subscription: subscriptionReducer,
  userRequest: userRequestReducer,
  stripe: stripeReducer,
  user: userReducer,
  product: persistReducer(productPersistConfig, productReducer)
});

export { rootPersistConfig, rootReducer };
